import { Syntax } from '@cld/code-snippet-next';
import { SdkSnippet, SnippetLanguage } from '../types';

const syntaxMap: Record<SnippetLanguage, Syntax> = {
  url: 'url',
  http: 'url',
  https: 'url',
  ruby: 'ruby',
  php: 'php',
  nodejs: 'javascript',
  java: 'java',
  js: 'javascript',
  jquery: 'javascript',
  react: 'jsx',
  vue: 'javascript',
  vuejs: 'javascript',
  angular: 'javascript',
  dotnet: 'csharp',
  android: 'java',
  ios: 'swift',
  jsx: 'jsx',
  python: 'python',
  csharp: 'csharp',
};

const removeNonAlphabeticChars = (str: string) => str.replace(/[\W_]/g, '');

export const getSdkSnippetSyntax = ({ displayName, sdkId, language }: SdkSnippet): Syntax => {
  const formattedDisplayName = displayName.toLowerCase();
  const formattedSdkId = removeNonAlphabeticChars(sdkId);
  return syntaxMap[formattedDisplayName] || syntaxMap[formattedSdkId] || syntaxMap[language] || language;
};
